import core from './nf-core'
import df from './df'
export default function(Vue) {
    Vue.use(core)
    Vue.use(df)
}
